import React from "react";
import { useHistory } from "react-router";
import VD from '../gallery/VD.png'

const Projects = () => {
  console.log(VD)
  const history = useHistory();
  const mockData = [
    {
      project_name: "Video Game Directory",
      project_link: "https://mattc-video-game-dir.netlify.app/",
      picture: VD,
      picName: 'VD'
    },
    {
      project_name: "Project2",
      project_link: "Link coming soon!",
    },
    {
      project_name: "Project3",
      project_link: "Link coming soon!",
    },
  ];
  return (
    <div className="projects-container">
      <section className="all-projects">
        {mockData.map((project) => (
          project.picture ?
          <div className={`project ${project.picName}`} key={project.project_name}>
            <h3 className="project-title">{project.project_name}</h3>
            <a className="project-link" href={project.project_link}>
              {project.project_link}
    
            </a>
          </div> 
          : <div className="project" key={project.project_name}>
          <h3 className="project-title">{project.project_name}</h3>
          <a className="project-link" href={project.project_link}>
            {project.project_link}
  
          </a>
        </div> 
        ))}
      </section>
      <div className="back-button" onClick={() => history.push("/")}>Back</div>
    </div>
  );
};

export default Projects;
